import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchInspectionPlansWithFilters, fetchInspectionPlanData } from './store/slice';
import { fetchPartsForQualityInspection } from '../../core/redux/part/slice';
import InspectionPlanTopHead from './inspectionplan-top-head';
import InspectionPlanContent from './inspectionplan-content';
import InspectionPlanModals from './inspectionplan-modals';
import { actions as inspectionPlanActions } from './store/slice';
import { fetchAllProcessStatuses } from '../../core/redux/status/slice';
import { showToast } from '../../core/redux/toast/slice';
import { parseInspectionPlanDeepLink } from './inspectionplan-deep-link';
import { selectInspectionPlanData } from './store/selectors';

const { resetFilters, setFilterVisible } = inspectionPlanActions;

const InspectionPlanView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);
  const inspectionPlans = useSelector(selectInspectionPlanData);

  useEffect(() => {
    dispatch(fetchInspectionPlansWithFilters());
    dispatch(fetchPartsForQualityInspection());
    dispatch(fetchAllProcessStatuses());
    return () => {
      dispatch(resetFilters());
      dispatch(setFilterVisible(false));
    };
  }, []);

  useEffect(() => {
    const deepLink = parseInspectionPlanDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = `${deepLink.inspectionPlanId || ''}:${deepLink.partId || ''}:${deepLink.partNumber || ''}`;
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }

    let inspectionPlanId = deepLink.inspectionPlanId;
    const list = Array.isArray(inspectionPlans) ? inspectionPlans : [];

    if (!inspectionPlanId && list.length > 0) {
      const match = list.find(item => {
        const itemPlanId = Number(item.inspectionPlanId ?? item.id);
        const itemPartId = Number(item.partId);
        const itemPartNumber = String(item.partNumber || item.partName || '').trim().toLowerCase();
        if (deepLink.partId && Number.isFinite(itemPartId) && itemPartId === deepLink.partId) {
          return true;
        }
        if (deepLink.partNumber && itemPartNumber === deepLink.partNumber.toLowerCase()) {
          return true;
        }
        if (deepLink.inspectionPlanId && Number.isFinite(itemPlanId) && itemPlanId === deepLink.inspectionPlanId) {
          return true;
        }
        return false;
      });
      inspectionPlanId = Number(match?.inspectionPlanId ?? match?.id) || null;
    }

    if (!inspectionPlanId) {
      if (list.length > 0) {
        dispatch(
          showToast({
            message: 'Could not open the inspection plan from this notification.',
            type: 'warning',
          }),
        );
        openedDeepLinkKeyRef.current = key;
      }
      return undefined;
    }

    dispatch(fetchInspectionPlanData({ inspectionPlanId }));
    openedDeepLinkKeyRef.current = key;
    return undefined;
  }, [dispatch, location.search, inspectionPlans]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>InspectionPlan</h4>
              </div>
            </div>
            <InspectionPlanTopHead />
          </div>
          <InspectionPlanContent />
          <InspectionPlanModals />
        </div>
      </div>
    </div>
  );
};

export default InspectionPlanView;
